import React, {useEffect, useState} from "react";
import Forms from "../../../bricks/form/Forms";
import {axiosInstance} from "../../../bricks/axios";
import {API} from "../../../config/Config";
import OtherTestItem from "./OtherTestItem";
import {useAppData} from "../../../context/AppDataContext";

import "./OtherTestModalContent.scss";

const OtherTestModalContent = ({handleSelectNewTest, close, testData}) => {
    const {setError, setSuccess, selectedPeriod, setPeriod} = useAppData();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({name: '', percentPassedThreshold: 80, testDefinitionList: []});
    const [file, setFile] = useState();

    useEffect(() => {
        if (testData) {
            setFormData({
                name: testData.name,
                percentPassedThreshold: testData.percentPassedThreshold,
                testDefinitionList: testData.testDefinitionList
            })
        }
    }, []);

    const _getRequestBody = () => {
        const body = new FormData();
        body.append('file', file);
        body.append('period', selectedPeriod);
        if (testData) {
            body.append('otherTestId', testData._id);
        }
        body.append('otherTestConfig', JSON.stringify(formData));
        return body;
    }

    const _handleSubmit = async () => {
        let id;
        try {
            setIsLoading(true);
            const reqBody = _getRequestBody();
            let response;
            // if testData exists, we want to update existing test by testData._id
            if (testData) {
                const {method, url} = API.updateOtherTestQuestionsFile(testData._id);
                response = await axiosInstance[method](url, reqBody);
            } else {
                // if testData isn't exists we want to create a new test
                const {method, url} = API.uploadOtherTestQuestionsFile;
                response = await axiosInstance[method](url, reqBody);
                id = response.data.period.otherTestList[response.data.period.otherTestList.length - 1]._id;
                console.log(id);
                handleSelectNewTest(id);
            }
            setPeriod(response.data.period);
            setSuccess(testData ? "Test úspěšně upraven" : "Test úspěšně vytvořen");
            close();
        } catch (e) {
            console.log(e);
            setError(e);
        } finally {
            setIsLoading(false);
        }
    }

    const handleTestChange = (newTest) => {
        setFormData(newTest);
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0])
    };

    return (
        <form onSubmit={_handleSubmit} className="OtherTestModalContent">
            <OtherTestItem
                disabled={isLoading}
                test={formData}
                onTestChange={handleTestChange}
                onFileChange={handleFileChange}
            />
            <div className="modal-footer">
                <Forms.Button onClick={close} dark label="Zavřít" disabled={isLoading}/>
                <Forms.Button onClick={_handleSubmit} label="Uložit" disabled={isLoading}/>
            </div>
        </form>
    );
}

export default OtherTestModalContent;